import React from 'react';
import styles from '../button/Button.module.css';

const DownloadButton = ({ text, link, fileName }) => {
  return (
    <a href={link} target="_blank" rel="noreferrer" className={styles.button}>
      {text}
    </a>
  );
};

export default DownloadButton;
